import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge/Badge.jsx';

const NotificationsBadge = ({count}) => {
  return (
    <Badge variant="danger" aria-label={`Notifications: ${count}`}>
      {count}
    </Badge>
  );
};

NotificationsBadge.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default NotificationsBadge;
